import { FC, useEffect, useState } from "react";
import Tilt from "react-parallax-tilt";
import { Container, Row, Col } from "react-bootstrap";

import "./Landing.scss";
import Header from "../../components/Header";
import { WalletAddressPicker } from "../../components/WalletAddressPicker";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import "../../assets/scss/common.scss";
import ReactGA from "react-ga4";
import ApiService from "../../services/ApiService";
import { TrendingCollectionListClass } from "../../utils/HelperClass/CommonClass";

const MyTitleStyle = {
	backgroundImage: "url(/Vector2.png)",
};

const settings = {
	dots: false,
	arrows: false,
	centerMode: true,
	infinite: true,
	centerPadding: "0px",
	autoplay: true,
	autoplaySpeed: 2000,
	speed: 300,
	slidesToShow: 5.48,
	slidesToScroll: 1,
	rtl: true,
	responsive: [
		{
			breakpoint: 1600,
			settings: {
				slidesToShow: 4.4,
			},
		},
		{
			breakpoint: 1300,
			settings: {
				slidesToShow: 3.4,
			},
		},
		{
			breakpoint: 1100,
			settings: {
				slidesToShow: 2.4,
			},
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1.7,
			},
		},
	],
};
export const LandingPage: FC = (props: any) => {
	let navigate = useNavigate();
	const [TrendingCollection, setTrendingCollection] = useState<
		TrendingCollectionListClass[]
	>([]);

	useEffect(() => {
		async function getTrendingCollection() {
			const LandingSlider = await ApiService.GetTrendingNFTCollection();
			setTrendingCollection(LandingSlider);
		}
		getTrendingCollection();
	}, []);

	return (
		<>
			<Header isTransparent />
			<main className="main-content">
				<div className="inner-content">
					<section className="main-wrapper">
						<Container>
							<Row>
								<Col lg={8}>
									<div className="left-part-main">
										<div className="page-title">
											Flex your <span className="art-text">ART</span>
											<br />
											collection in{" "}
											<span className="style-text" style={MyTitleStyle}>
												style
											</span>
										</div>
										<div className="page-title bottom-part">
											<div className="slider-main">
												<div className="slide">
													<div className="slider-image">
														<img
															className="d-block"
															src="/wallet.gif"
															alt="wallet"
														/>
													</div>

													<div>
														<div className="slider-title">Set Up Wallet</div>
														<p className="slider-content">
															Set Up your own Wallet through our protected
															system
														</p>
													</div>
												</div>
												<div className="slide">
													<div className="slider-image">
														<img
															className="d-block"
															src="/dot.gif"
															alt="loading"
														/>
													</div>
													<div>
														<div className="slider-title">Display NFT</div>
														<p className="slider-content">
															Display your favorite NFT with Public Key
														</p>
													</div>
												</div>
												<div className="slide">
													<div className="slider-image">
														<img
															className="d-block"
															src="/wallet.gif"
															alt="wallet"
														/>
													</div>

													<div>
														<div className="slider-title">Set Up Wallet</div>
														<p className="slider-content">
															Set Up your own Wallet through our protected
															system
														</p>
													</div>
												</div>
												<div className="slide">
													<div className="slider-image">
														<img
															className="d-block"
															src="/dot.gif"
															alt="loading"
														/>
													</div>
													<div>
														<div className="slider-title">Display NFT</div>
														<p className="slider-content">
															Display your favorite NFT with Public Key
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</Col>
								<Col lg={4}>
									<div className="right-part">
										<WalletAddressPicker></WalletAddressPicker>
										<div className="scroll-btn">
											<div className="slider-image">
												<img
													className="d-block"
													src="/scroll.gif"
													alt="scroll"
												/>
											</div>
										</div>
									</div>
								</Col>
							</Row>
						</Container>
						<div className="middle-part">
							<div className="img-block-bottom">
								<div className="scattboard-img">
									<Tilt
										className="parallax-effect-img"
										tiltMaxAngleX={30}
										tiltMaxAngleY={30}
										perspective={400}
										transitionSpeed={1200}
										scale={0.9}
										gyroscope={true}
									>
										<img src="/surface.png" alt="surface" />
									</Tilt>
								</div>
							</div>
						</div>
					</section>
					<section className="sliderSection">
						<Container>
							<div className="titleWrapper">
								<div className="page-title">
									Top <span className="yellowText"> Trending </span>
									Collections
								</div>
								<a
									onClick={() => {
										navigate(`/trending`);
									}}
									className="showMore d-none d-lg-block"
								>
									View More Collection
									<img src="right-arrow.png" alt="arrow" />
								</a>
							</div>
						</Container>
						{TrendingCollection.length > 0 ? (
							<Slider {...settings}>
								{TrendingCollection.map((slider) => (
									<div className="topArtBox" key={slider.imageUrl}>
										<div className="topArtImageBox">
											<img
												className="mainImage"
												src={slider.imageUrl}
												alt={slider.name}
											/>
											<div className="topArtImageBoxHover">
												<div className="topArtHoverImage">
													<img src={slider.imageUrl} alt={slider.name} />
												</div>
												<div className="topArtTitle">{slider.name}</div>
												{/* <div className="IconWitheText">
                  <img src="triangle.png" alt="triangle" />
                  {slider.price}
                </div> */}
											</div>
										</div>
									</div>
								))}
							</Slider>
						) : (
							<Row>
								<h1 className="loading">Loading ...</h1>
							</Row>
						)}
						<div className="mobileShowMore d-lg-none d-block">
							<Container>
								<a
									onClick={() => {
										navigate(`/trending`);
									}}
									className="showMore d-inline-block"
								>
									View More Collection
									<img src="right-arrow.png" alt="arrow" />
								</a>
							</Container>
						</div>
					</section>
				</div>
				<Footer></Footer>
			</main>
		</>
	);
};

export default LandingPage;
